import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms'
import {CoordinatorsService} from '../../../services/coordinators.service'
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-coordinator-add-edit',
    templateUrl: './coordinator-add-edit.component.html',
    styleUrls: ['./coordinator-add-edit.component.scss'],
    standalone: false
})
export class CoordinatorAddEditComponent implements OnInit {
  public addDespachosForm: UntypedFormGroup;
  dateValid:boolean=false;
  currentDate = new Date();
  constructor(
    private _dialogRef: MatDialogRef<CoordinatorAddEditComponent>,
    private _coordinatorsService:CoordinatorsService,
    private _sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if(this.data.isInsert)
        {
          this.addDespachosForm = new UntypedFormGroup({
            Realizada: new UntypedFormControl('', Validators.required),
            Comentarios: new UntypedFormControl('', Validators.required),
            Coordinador: new UntypedFormControl(this.data.coordinador),
          });
        }
        else{
          this.addDespachosForm = new UntypedFormGroup({
            Realizada: new UntypedFormControl(this.data.realizada, Validators.required),
            Comentarios: new UntypedFormControl(this.data.comentarios, Validators.required),
            Coordinador: new UntypedFormControl(this.data.coordinador),
            id: new UntypedFormControl(this.data.id),
          });
        }
     }

  ngOnInit(): void {
    this.realizadaValidationMessageDisplay();
  }

  realizadaValidationMessageDisplay()
  {
    this.addDespachosForm.get("Realizada").valueChanges.subscribe(x => {
      if(this.addDespachosForm.get('Realizada').value >this.currentDate && this.currentDate != this.addDespachosForm.get('Realizada').value)
        {
          this.dateValid=true;
        }
        else{
          this.dateValid=false;
        }
   });
  }

  public onClose(): void {
    this._dialogRef.close();
  }
  
  public onSave() : void{
    this.addDespachosForm.markAllAsTouched();
    this.addDespachosForm.updateValueAndValidity();
    if (this.addDespachosForm.valid) {

      if(this.data.isInsert)
      {
        this.currentDate=WithoutTime(this.currentDate);
        if(this.addDespachosForm.get('Realizada').value >this.currentDate && this.currentDate != this.addDespachosForm.get('Realizada').value)
        {
          this.dateValid=true;
        }
        else{
          this.saveData();
          this.dateValid=false;
        }
       
      }
      else{
        this.currentDate=WithoutTime(this.currentDate);
        if(this.addDespachosForm.get('Realizada').value >this.currentDate && this.currentDate != this.addDespachosForm.get('Realizada').value)
        {
          this.dateValid=true;
        }
        else{
          this.editData();
          this.dateValid=false;
        }
       
      }
    }
  }

  saveData(){
    this._coordinatorsService.AddDespacho(this.addDespachosForm.value).subscribe(res => {   
      if(res)
      {
        this.onClose()
        this._sharedService.ShowSnackBar('Insertado correctamente', 'Okay', 2000);
      }
    }, err => {
    console.error(err);
      this.onClose();
      this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
    })
  }

  editData(){
    this._coordinatorsService.EditDespacho(this.addDespachosForm.value).subscribe(res => {   
      if(res)
      {
        this.onClose()
        this._sharedService.ShowSnackBar('Actualizado correctamente', 'Okay', 2000);
      }
    }, err => {
    console.error(err);
      this.onClose();
      this._sharedService.ShowSnackBar('Error al actualizar', 'Okay', 2000);
    })
  }

}
function WithoutTime(dateTime) {
  var date = new Date(dateTime.getTime());
  date.setHours(0, 0, 0, 0);
  return date;
}